import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';

import {GetAllAdPayloadModel, CreateAdPayloadModel, UpdateAdPayloadModel} from './ad_interfaces';
import {Observable, of} from 'rxjs';


@Injectable({providedIn: 'root'})
export class AdService{

  url:string = `${environment['API_URL']}`

  constructor(private http: HttpClient,) {} //end constructor


  gets(endpoint: string, is_mocked: boolean = false): Observable<GetAllAdPayloadModel[]> {

    if (is_mocked) {
      return of<GetAllAdPayloadModel[]>(
        [
          {
            "ad_id": "1",
            "name": "Mock Client",
          }
        ]
      )
    } // end if is_mocked

    let url: string = `${this.url}/${endpoint}`;
    return this.http.get<GetAllAdPayloadModel[]>(url);
  } // end gets

  get(endpoint: string, is_mocked: boolean = false): Observable<GetAllAdPayloadModel> {

    if(is_mocked) {
      return of<GetAllAdPayloadModel>(

        {
          "ad_id": "1",
          "name": "Mock Client"
        }

      )
    } //end if is_mocked

    let url: string = `${this.url}/${endpoint}`;
    return this.http.get<GetAllAdPayloadModel>(url);
  } //end gets

  post(endpoint: string, data: CreateAdPayloadModel){
    return this.http.post<any>(`${this.url}/${endpoint}`, data,{observe: 'response'});
  } //end post

  put(endpoint: string, data: UpdateAdPayloadModel){
    return this.http.put<any>(`${this.url}/${endpoint}`, data,{observe: 'response'});
  } //end put

  delete(endpoint: string): Observable<any> {
    const url = `${this.url}/${endpoint}`;
    return this.http.delete<any>(url);
  } //end getAlerts





} //end AdgroupService
